export function BillingTerms({ billing }) {
  if (!billing) return null;
  return (
    <div className="rounded-xl border border-slate-800 bg-slate-950/60 p-5" data-testid="billing-terms">
      <div className="flex flex-wrap gap-6 mb-4">
        <div><p className="text-xs uppercase tracking-widest text-slate-500 font-mono">Due today</p>
          <p className="text-2xl font-display font-bold text-white" data-testid="billing-initial-payment">${billing.initial_payment?.toLocaleString()}</p>
          <p className="text-xs text-slate-400" data-testid="billing-setup-fee">${billing.setup_fee} one-time setup + ${billing.monthly_price} first month</p></div>
        <div><p className="text-xs uppercase tracking-widest text-slate-500 font-mono">Then</p>
          <p className="text-2xl font-display font-bold text-white" data-testid="billing-monthly-price">${billing.monthly_price}<span className="text-sm text-slate-400 font-normal">/month</span></p>
          <p className="text-xs text-slate-400">No free trial</p></div>
      </div>
      <ul className="list-disc pl-5 space-y-1.5 text-sm text-slate-300">
        {billing.terms.map((t) => <li key={t}>{t}</li>)}
      </ul>
      {billing.mode === "test" && <p className="mt-3 text-xs text-amber-300" data-testid="billing-test-mode">TEST MODE. No real charges. Use card 4242 4242 4242 4242.</p>}
    </div>
  );
}
